import React, { useEffect, useState, useContext } from "react";
import "./transactionsv2.scss";
import Navbar from "../Navbar";
import Banner from "../Banner";
import Axios from "axios";
import { useHistory, Link } from "react-router-dom";
import StateContext from "../../StateContext";
import LazyLoad from "react-lazy-load";
import LoaderAnimation from "../LoaderAnimation";
import Stack from "@mui/material/Stack";
import { Button, IconButton } from "@material-ui/core";
import TextField from "@mui/material/TextField";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Avatar from "@mui/material/Avatar";
import InputAdornment from "@mui/material/InputAdornment";
import searchIcon from "../../Assets/images/searchIcon.svg";
import Credit from "../../Assets/images/credit.svg";
import Arrow from "../../Assets/images/arrow.svg";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import maleLogo from "../../Assets/images/male-avatar.png";
import promocodeNew from "../../Assets/images/promocodeNew.svg";
import { RangeDatePicker } from "react-google-flight-datepicker";
import "react-google-flight-datepicker/dist/main.css";

// import localizations pakeges
import { withTranslation, useTranslation, Trans } from "react-i18next";
import { responsiveFontSizes } from "@mui/material";
import { getCookie } from "../../Functions/cookieFunction";
import { handleError } from "../../Functions/getAlert";
import DispatchContext from "../../DispatchContext";
import vendorsConfig from "../../vendorsConfig";

const Loading = () => {
  <div className="post loading">
    <h5>Loading ...</h5>
  </div>;
};
const Transactionsv2 = (props) => {
  const appDispatch = useContext(DispatchContext);
  const { t } = useTranslation();
  const appState = useContext(StateContext);
  const [value, setValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [seeMore, setSeeMore] = useState(5);
  const [walletHistory, setWalletHistory] = useState([]);
  const [searchTransactionArr, setsearchTransactionArr] = useState([]);
  const [showfilterTransaction, setshowfilterTransaction] = useState(false);
  const [MainTransactionState, setMainTransactionState] = useState([]);
  const [TransactionType, setTransactionType] = useState("paginate");

  useEffect(() => {
    const fetchTransactionByKeyWord = async () => {
      try {
        if (TransactionType === "paginate") {
          setIsLoading(true);
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL
            }transaction/new_filter?paginate=${10}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${getCookie("tokenAuth")}`,
              },
            }
          );
          setMainTransactionState(response.data.data.data);
          props.setCount(response.data.data.data.length);
          setIsLoading(false);
        } else if (TransactionType === "all") {
          setIsLoading(true);
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}transaction/new_filter`,
            {},
            {
              headers: {
                Authorization: `Bearer ${getCookie("tokenAuth")}`,
              },
            }
          );
          setMainTransactionState(response.data.data);
          props.setCount(response.data.data.length);
          setIsLoading(false);
        }
      } catch (e) {
        handleError(e, appDispatch);
      }
    };
    fetchTransactionByKeyWord();
  }, [TransactionType]);
  const onDateChange = async (startDate, endDate) => {
    var combineStartDate;
    var combineEndDate;
    if (startDate !== null) {
      let startDateDate = startDate.getDate();
      let startDateMonth = startDate.getMonth() + 1;
      let startDateYear = startDate.getFullYear();
      combineStartDate = `${startDateDate}-${startDateMonth}-${startDateYear}`;
    }
    if (endDate !== null) {
      let endDateDate = endDate.getDate();
      let endDateMonth = endDate.getMonth() + 1;
      let endDateYear = endDate.getFullYear();
      combineEndDate = `${endDateDate}-${endDateMonth}-${endDateYear}`;
    }

    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}transaction/new_filter`,
        {
          from_date: combineStartDate,
          to_date: combineEndDate,
        },
        {
          headers: {
            Authorization: `Bearer ${appState.token}`,
          },
        }
      );
      setMainTransactionState(response.data.data);
      props.setCount(response.data.data.length);
      setIsLoading(false);
      setTransactionType("DateRange");
    } catch (e) {
      handleError(e, appDispatch);
      setIsLoading(false);
      setTransactionType("DateRange");
    }
  };
  const handleViewAll = () => {
    setTransactionType("all");
  };
  if (!appState.loggedIn) {
    history.push("/");
  }

  return (
    <>
      <div id="transactionsv2Parent" className="data-content__dashboard">
        <div className="data-row__dashboardv2">
          <Stack>
            {isLoading ? (
              <div style={{ position: "relative", height: "250px" }}>
                <LoaderAnimation />
              </div>
            ) : (
              <>
                <div className="container-fluid  BalanceCardParent">
                  <div className="row  justify-content-center">
                    <div className="my-3 profileInfoParent  d-flex justify-content-center">
                      <div className="col-6 px-0 d-flex flex-column justify-content-center ">
                        <h6
                          className={`created ${appState.langValue === "ar"
                              ? "text-right"
                              : "text-left"
                            }`}
                        >
                          Welcome
                        </h6>{" "}
                        <h4
                          className={`m-0 ${appState.langValue === "ar"
                              ? "text-right"
                              : "text-left"
                            }`}
                        >
                          {" "}
                          <strong className="textEB5B5E">
                            {" "}
                            {appState.loggedIn
                              ? appState.profile.userFirstName === "" ||
                                appState.profile.userFirstName === null ||
                                appState.profile.userFirstName === undefined
                                ? `${vendorsConfig.APP_NAME} User`
                                : appState.profile.userFirstName
                              : ""}
                          </strong>
                        </h4>{" "}
                        <div></div>
                      </div>
                      <div className="col-6 px-0 d-flex  flex-column justify-content-center align-items-end">
                        {appState.profile.userImage ? (
                          <img
                            src={appState.profile.userImage}
                            alt=""
                            height="60px"
                            width="60px"
                            style={{ borderRadius: "50%" }}
                          />
                        ) : (
                          <img
                            src={maleLogo}
                            alt=""
                            height="60px"
                            width="60px"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="row  justify-content-center">
                    <div className="BalanceCard my-3  d-flex justify-content-center">
                      <div className="col-7   d-flex flex-column justify-content-center ">
                        <h6
                          className={`created ${
                            appState.langValue === "ar"
                              ? "text-right"
                              : "text-left"
                          }`}
                        >
                          {t("wallet.your-balance")}:
                        </h6>{" "}
                        <h4
                          className={`m-0 ${
                            appState.langValue === "ar"
                              ? "text-right"
                              : "text-left"
                          }`}
                        >
                          {" "}
                          <strong className="textEB5B5E">
                            {appState.profile.walletAmount
                              ? parseFloat(appState.profile.walletAmount)
                              : "0 "}{" "}
                            {t("KWD")}{" "}
                          </strong>
                        </h4>{" "}
                        <div className="d-flex">
                          <Link to="/wallet">
                            <Button className="viewAll" variant="text">
                              {t("drawer.view-wallet")}
                              {appState.langValue === "ar" ? (
                                <KeyboardArrowLeftIcon />
                              ) : (
                                <KeyboardArrowRightIcon />
                              )}
                            </Button>
                          </Link>
                        </div>{" "}
                      </div>
                      <div className="col-5  d-flex  flex-column justify-content-start align-items-end">
                        <h6 className="created">{t("wallet.cashback")} :</h6>{" "}
                        <h4 className="">
                          {" "}
                          <strong>0.00 {t("KWD")} </strong>
                        </h4>{" "}
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="container pt-5">
                  <div className="row d-flex justify-content-center">
                    <div className="col-sm-10 d-flex justify-content-between align-items-center">
                      <h5 className="">
                        {" "}
                        <strong>{t("dashboard.transactions")} </strong>
                      </h5>

                      <Button
                        className="viewAll"
                        variant="text"
                        onClick={handleViewAll}
                      >
                        {t("drawer.view-all")}
                        {appState.langValue === "ar" ? (
                          <KeyboardArrowLeftIcon />
                        ) : (
                          <KeyboardArrowRightIcon />
                        )}
                      </Button>
                    </div>
                  </div>

                  <div className="row d-flex direction-ltr justify-content-center">
                    <div className="col-sm-10">
                      <div className="row d-flex justify-content-between align-items-center  pl-0 pr-0 dashboardSearchTransac">
                        <div className="col-12 mt-2">
                          <RangeDatePicker
                            startDatePlaceholder={t("dashboard.Start-Date")}
                            endDatePlaceholder={t("dashboard.End-Date")}
                            onChange={(startDate, endDate) =>
                              onDateChange(startDate, endDate)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {MainTransactionState.length > 0 ? (
                  <>
                    <div className="row d-flex justify-content-center m-0 mainTransactionHistoryRow">
                      {showfilterTransaction
                        ? searchTransactionArr.map((wallet, index) => {
                          return (
                            <div className="col-md-8 px-0" key={index}>
                              <LazyLoad
                                height={"100%"}
                                placeholder={<Loading />}
                              >
                                <HistoryRow
                                  data_id={wallet.id}
                                  amount={wallet.amount}
                                  status={wallet.status}
                                  received_by={wallet.received_by}
                                  sent_by={wallet.sent_by}
                                  created={wallet.created_at}
                                  source={wallet.source}
                                />
                              </LazyLoad>
                            </div>
                          );
                        })
                        : MainTransactionState.map((wallet, index) => {
                          return (
                            <div className="col-md-8 px-0" key={index}>
                              <LazyLoad
                                height={"100%"}
                                placeholder={<Loading />}
                              >
                                <HistoryRow
                                  data_id={wallet.id}
                                  amount={wallet.amount}
                                  status={wallet.status}
                                  received_by={wallet.received_by}
                                  sent_by={wallet.sent_by}
                                  created={wallet.created_at}
                                  source={wallet.source}
                                />
                              </LazyLoad>
                            </div>
                          );
                        })}
                    </div>
                  </>
                ) : (
                  <NoTransactions TransactionType={TransactionType} t={t} />
                )}
              </>
            )}
          </Stack>
        </div>
      </div>
    </>
  );
};
function NoTransactions(props) {
  const { t, TransactionType } = props;
  return (
    <>
      <div className="empBox">
        <div className="text-center py-5">
          <div className="BoxImg">
            <img src={promocodeNew} alt="" className="img-fluid" />
          </div>
          <div className="mt-4">
            <p>
              <strong>
                {TransactionType === "DateRange"
                  ? t("dashboard.You-have-no-transaction-for-this-period")
                  : t("dashboard.You-have-no-transaction")}
                !
              </strong>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
function HistoryRow(props) {
  const appState = useContext(StateContext);
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <>
      <div className="post">
        <a>
          <div className="data-row" id={"dep"}>
            <div className="row m-0 align-items-center">
              <div
                className={`${appState.langValue === "ar" ? "pl-4" : ""
                  } col-8 d-flex align-items-center  p-0`}
              >
                {props.source === "Invoice" ? (
                  <Avatar src={Credit} className="creditAvatar" />
                ) : (
                  <Avatar className="ArrowAvatar" src={Arrow} />
                )}

                <div
                  className={`${appState.langValue === "ar" ? "pr-4" : "pl-4"
                    } data-row__price `}
                >
                  {props.source === "Invoice" ? (
                    <div className="row m-0  ">
                      <div className="text">
                        <h6 className="">
                          {" "}
                          <strong> {props.sent_by}</strong>
                        </h6>
                      </div>{" "}
                    </div>
                  ) : props.source === "PartialInvoice" ? <div className="row m-0  ">
                    <div className="text">
                      <h6 className="">
                        {" "}
                        <strong> {props.sent_by}</strong>
                      </h6>
                    </div>{" "}
                  </div> : (
                    <div className="row m-0 align-items-center p-0">
                      <div className="text">
                        <h6 className="">
                          <strong>Top Up at walllet </strong>
                        </h6>
                      </div>{" "}
                    </div>
                  )}
                  <div className="sourceAndCreated">
                    <h6
                      className={` ${appState.langValue === "ar" ? "text-right" : "text-left"
                        }`}
                    >
                      {props.source}
                    </h6>
                    <h6
                      className={`created ${appState.langValue === "ar" ? "text-right" : "text-left"
                        }`}
                    >
                      {props.created}
                    </h6>
                  </div>
                </div>
              </div>
              <div
                className={`${appState.langValue === "ar" ? "pl-4" : "text-right"
                  } col-4 d-flex align-items-center justify-content-end p-0`}
              >
                <div className="data-row__price">
                  <h5 className="">
                    <strong
                      className={`${props.status == "Success"
                          ? props.source == "Invoice"
                            ? "text-green"
                            : "text-green"
                          : ""
                        }`}
                    >
                      + {t(`"KWD"`)} {parseFloat(props.amount).toFixed(3)}
                    </strong>
                  </h5>
                  <p
                    className={`${props.status == "Success"
                        ? "text-green"
                        : props.status == "Pending"
                          ? "text-orange"
                          : " text-red"
                      } m-0 small status`}
                  >
                    {" "}
                    {props.status}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </>
  );
}

export default withTranslation()(Transactionsv2);
